<template>
  <v-flex data-qa="cashisaaccount-flex-kl0w8h">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 pt-0" data-qa="cashisaaccount-layout-yuwu2h">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="cashisaaccount-flex-thk1gh">
        <v-container data-qa="cashisaaccount-container-1y3i0j">
          <v-flex xs12 sm12 md12 lg12 xl12 class="px-2" data-qa="cashisaaccount-flex-ydo7">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="cashisaaccount-flex-bperjf">
              <v-row no-gutters class="pb-2" data-qa="cashisaaccount-row-hd2ye">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                    {{$t("common.savingsSubTitle_2")}} <font v-if="showTotalAccountsAvailable">({{ cashIsaAccount.accounts.length }})</font>
                  </font>
              </v-row>
            </v-flex>
            <v-row class="px-2 pl-6 py-2" data-qa="cashisaaccount-row-njv11q">
              <v-col xs12 sm12 md9 lg8 xl8>
                <span class="subheading font-weight-medium white--text">
                  {{ $t("accountDetails.overallIsaAllowance") }}
                </span>
                <br>
                <span class="text-h5 font-weight-bold white--text">
                  {{ overallIsaAllowance}}
                </span>
              </v-col>
              <v-col xs12 sm12 md3 lg4 xl4>
                <span class="subheading font-weight-medium white--text">
                  {{ $t("accountDetails.isaAllowanceRemaining") }}
                </span>
                <br>
                <span class="text-h5 font-weight-bold white--text">
                  {{ overallIsaRemaining }}
                </span>
              </v-col>
              <v-col xs12 sm12 md3 lg4 xl4>
                <span class="subheading font-weight-medium white--text">
                  {{ $t("accountDetails.isaAllowanceUsed") }}
                </span>
                <br>
                <span class="text-h5 font-weight-bold white--text">
                  {{ overallIsaUsed }}
                </span>
              </v-col>
              <v-col xs12 sm12 md3 lg4 xl4>
                <span class="subheading font-weight-medium white--text">
                  {{ $t("accountDetails.voidedAmount") }}
                </span>
                <br>
                <span class="text-h5 font-weight-bold white--text">
                  {{ voidedAmount }}
                </span>
              </v-col>
              <v-layout row wrap v-if="showTotalBalance && !isMultiCurrency" data-qa="cashisaaccount-layout-jrrk2g">
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="cashisaaccount-flex-2pwgqs">
                  <font class="subheading-1 font-weight-medium white--text">{{
                    $t("accountDetails.totalBalance")
                  }}</font>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="cashisaaccount-flex-i9e8yl">
                  <font class="text-h5 font-weight-bold white--text">{{
                    $formatter.currency.format(accDetails.myBalance, accDetails.currency)
                  }}</font>
                </v-flex>
              </v-layout>

              <v-layout v-if="enableOpenNewAccountOption" class="py-2" data-qa="cashisaaccount-layout-lds45g">
                <v-flex sm12 xs12 md12 lg12 xl12 class="text-right" data-qa="cashisaaccount-flex-h1vj5w">
                  <v-btn
                    @click="goToOffer('SVGS')"
                    color="white"
                    class="text-none"
                    outlined
                     data-qa="cashisaaccount-btn-5rqz6d">{{$t("common.openNewAccountLabel")}}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="cashisaaccount-flex-t0ltek">
      <CardLayout :config="cashIsaAccount" />
    </v-flex>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import CardLayout from '@/views/home/HomeCards.vue'
import Loader from '../../components/common/Loader.vue'
import commonService from '@/service/commonService.js'

export default {
  name: 'CashIsaAccount',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      accountType: 'SVGS',
      loaderEnabled: false,
      cashIsaAccount: {
        title: this.$t('common.savingsSubTitle_2'),
        cardLabels: false,
        openNewACCard: false,
        enableShowMore: false,
        accounts: []
      },
      accDetails: {
        myBalance: 0,
        currency: '',
        series: []
      },
      baseCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      enableOpenNewAccountOption: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
      showTotalBalance: this.$appSettings.defaultConfigurations.totalBalanceSection.enableSavingsSection,
      showTotalAccountsAvailable: this.$appSettings.defaultConfigurations.showTotalAccountsAvailable.enableSavingsSection,
      viewClosedAccountsList: this.$appSettings.defaultConfigurations.viewClosedAccountsList,
      excludedAccountStatus: this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList,
      isMultiCurrency: false,
      overallIsaAllowance: '',
      overallIsaUsed: '',
      overallIsaRemaining: '',
      voidedAmount: ''
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  async created () {
    this.customerId = JSON.parse(sessionStorage.getItem('username'))
    this.getOverallSubScription(this.customerId)
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.cashIsaAccount.enableShowMore = true
    } else this.cashIsaAccount.enableShowMore = false
    // const exclusionList = this.$appSettings.uiFieldsDisplayConfigurations
    //   .tableColumns.accountListTables.exclusionList
    event.$on('set_myAccounts', () => {
      // this.fetchAccounts()
      this.getListOfAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      // this.fetchAccounts()
      this.getListOfAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    goToOffer (type) {
      this.$router.push({
        name: 'Savings Products',
        params: { accountType: type }
      })
    },
    getListOfAccounts () {
      this.loaderEnabled = true
      const data = store.getters['userStore/userData'].cashIsaAccount
      if (data) {
        this.cashIsaAccount.accounts = data
          ? [...data]
          : []
        if (this.cashIsaAccount.accounts.length) {
          this.cashIsaAccount.accounts = _.filter(this.cashIsaAccount.accounts,
            account => {
              if (this.viewClosedAccountsList.includes(account.accountType) && account.accountStatus === 'CLOSED') {
                return account
              } else return !(this.excludedAccountStatus.includes(account.accountStatus))
            })
          // TODO this.cashIsaAccount.accounts.forEach((key, index) => {
          //   if (key.currency !== this.baseCurrency) {
          //     this.isMultiCurrency = true
          //   }
          // })
        }
        // for (const i in data) {
        //   if (data[i].accountList[0]) {
        //     this.accDetails.currency = data[i].accountList[0].currency
        //   }
        //   switch (data[i].label) {
        //     case 'savingAccounts':
        //       this.accDetails.series.push(data[i].totalSavingBalance)
        //       this.accDetails.myBalance += data[i].totalSavingBalance
        //       break
        //     default:
        //       break
        //   }
        // }
      }
      this.loaderEnabled = false
    },
    // Currently, not in use
    fetchAccounts () {
      this.loaderEnabled = true
      const accounts = store.getters['userStore/userData'].myAccounts
      const cashIsaAccounts = accounts.savingsAccounts
        ? accounts.savingsAccounts.accountList
        : []
      if (cashIsaAccounts && cashIsaAccounts.length) {
        this.cashIsaAccount.accounts = []
        const excludeAccountStatus = ['BLOCKED', 'STOPPED']
        for (const i in cashIsaAccounts) {
          if (excludeAccountStatus.includes(cashIsaAccounts[i].accountStatus)) {
            cashIsaAccounts[i].balance = this.$t(
              'myAccounts.notAvailableLabel'
            )
          } else {
            if (!isNaN(cashIsaAccounts[i].balance)) {
              cashIsaAccounts[i].balance = this.getBalInfo(
                cashIsaAccounts[i].balance
              )
            } else {
              if (
                !cashIsaAccounts[i].balance &&
                cashIsaAccounts[i].accountStatus === 'ACTIVATED'
              ) {
                cashIsaAccounts[i].balance = this.$t(
                  'myAccounts.balanceInquiryRestricted'
                )
              }
            }
          }
          this.cashIsaAccount.accounts.push({
            ...cashIsaAccounts[i],
            status: this.$t(
              `systemEnums.casa.${savingsAccounts[i].accountStatus}`
            ),
            accountNumber: cashIsaAccounts[i].accountId
          })
        }
        this.loaderEnabled = false
      } else {
        this.loaderEnabled = false
      }
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].myAccounts
    },
    getBalInfo (bal) {
      if (bal !== undefined && bal.toString().trim().length > 0) {
        if (isNaN(bal)) {
          return bal
        } else {
          return this.$formatter.currency.format(bal)
        }
      } else {
        return this.$t('myAccounts.notAvailableLabel')
      }
    },
    async getOverallSubScription (customerId) {
      const response = await commonService.getOverallSubscrptionCashIsa(customerId)
      if (response && response.customerId) {
        this.overallIsaAllowance = this.$formatter.currency.format(response.totalSubscriptionAmount.amount, response.totalSubscriptionAmount.currency)
        this.overallIsaUsed = this.$formatter.currency.format(response.totalSubscriptionamtUsed.amount, response.totalSubscriptionamtUsed.currency)
        this.overallIsaRemaining = this.$formatter.currency.format(response.totalSubscriptionamtRemain.amount, response.totalSubscriptionamtRemain.currency)
        this.voidedAmount = this.$formatter.currency.format(response.totalVoidedAmount.amount, response.totalVoidedAmount.currency)
      }
    }
  }
}
</script>
